/**
 * Stable CSS class names for E2E — Product generation report page.
 */
export const PGR = {
    page: 'product-generation-report-page',
    loadingBar: 'product-generation-report-page__loading-bar',
    content: 'product-generation-report-page__content',

    filterCard: 'product-generation-report-page__filter-card',
    filterHeader: 'product-generation-report-page__filter-header',
    filterTitle: 'product-generation-report-page__filter-title',
    filterRow: 'product-generation-report-page__filter-row',
    inputUsername: 'product-generation-report-input--username',
    inputStartDate: 'product-generation-report-input--start-date',
    inputEndDate: 'product-generation-report-input--end-date',
    filterActions: 'product-generation-report-page__filter-actions',
    buttonApply: 'product-generation-report-input--button-apply',
    buttonClear: 'product-generation-report-input--button-clear',

    errorAlert: 'product-generation-report-page__error-alert',

    gridCard: 'product-generation-report-page__grid-card',
    gridHeaderRow: 'product-generation-report-page__grid-header-row',
    gridTitleGroup: 'product-generation-report-page__grid-title-group',
    gridTitle: 'product-generation-report-page__grid-title',
    buttonExportExcel: 'product-generation-report-input--button-export-excel',
    dataGridWrap: 'product-generation-report-page__data-grid-wrap',
    dataGrid: 'product-generation-report-page__data-grid',
} as const;

export const pgrCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

